import { API } from "aws-amplify";
import config from "./config";
import utf8 from "utf8";

export const addImageAndGetUrl = async (image: string, slug?: string) => {
  console.log(image, slug);
  const slugUtf8 = slug ? utf8.encode(slug) : undefined;
  console.log(slugUtf8);
  const { profilePictureUrl } = await API.post(config.apiName, "/addImage", {
    body: {
      slug,
      image,
    },
  });
  return profilePictureUrl;
};
